module.exports = __webpack_public_path__ + "img/austria-breast-cancer-female.b1d72574.png";